import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function TermosUso() {
  return (
    <div className="legal-container">
      <div className="legal-header">
        <h1>📜 Termos de Uso</h1>
        <p className="subtitle">Canal de Ética, Integridade e Ouvidoria - Grupo Vilarouca</p>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Aceitação dos Termos</h2>
          <p>
            Ao acessar e usar o Canal de Ética GV, você aceita estar vinculado a estes Termos de Uso.
            Se não concorda com qualquer parte, não use o sistema.
          </p>
          <div className="alert alert-info">
            <strong>⚠️ Leia também:</strong> Veja nossa <Link to="/privacidade">Política de Privacidade</Link>
            para entender como seus dados são protegidos.
          </div>
        </section>

        <section className="legal-section">
          <h2>2. Anonimato Garantido</h2>
          <h3>✅ O que Garantimos</h3>
          <ul>
            <li>Denúncias anônimas têm <strong>anonimato real</strong></li>
            <li>Não coletamos IP, cookies ou identificadores</li>
            <li>Acompanhamento seguro apenas com Protocolo + PIN</li>
            <li>Apenas pessoas autorizadas veem dados (com acesso RBAC)</li>
          </ul>

          <h3>⚠️ Importante</h3>
          <p>
            Se você optar por fazer uma denúncia <strong>identificada</strong>, seus dados pessoais
            (nome, email, telefone) serão coletados e protegidos com criptografia.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Proibições - Não Permitido</h2>
          <div className="prohibition-grid">
            <div className="prohibition-item">
              <span className="icon">🚫</span>
              <strong>Difamação</strong>
              <p>Não faça acusações sem base ou falsas contra pessoas específicas</p>
            </div>
            <div className="prohibition-item">
              <span className="icon">🚫</span>
              <strong>Falsas Acusações</strong>
              <p>Denúncias sabidamente falsas podem gerar consequências legais</p>
            </div>
            <div className="prohibition-item">
              <span className="icon">🚫</span>
              <strong>Crimes</strong>
              <p>Não use para reportar crimes (use a polícia) ou para atos ilegais</p>
            </div>
            <div className="prohibition-item">
              <span className="icon">🚫</span>
              <strong>Spam/Abuso</strong>
              <p>Não envie denúncias repetidas, ofensivas ou sem propósito legítimo</p>
            </div>
            <div className="prohibition-item">
              <span className="icon">🚫</span>
              <strong>Retaliação</strong>
              <p>Não use para se vingar de colegas ou competitors</p>
            </div>
            <div className="prohibition-item">
              <span className="icon">🚫</span>
              <strong>Dados Pessoais de Terceiros</strong>
              <p>Não divulgue informações privadas de outras pessoas</p>
            </div>
          </div>

          <div className="alert alert-danger">
            <strong>🚨 Consequências:</strong> Violações podem resultar em:
            <ul style={{marginTop: '10px'}}>
              <li>Investigação disciplinar</li>
              <li>Denúncia às autoridades competentes</li>
              <li>Ações legais civis ou criminais</li>
            </ul>
          </div>
        </section>

        <section className="legal-section">
          <h2>4. Sua Responsabilidade</h2>
          <p>
            Você é responsável por:
          </p>
          <ul>
            <li>A veracidade das informações que envia</li>
            <li>A veracidade de evidências anexadas</li>
            <li>Violações destes Termos que você cometer</li>
            <li>Qualquer dano decorrente de denúncias falsas</li>
          </ul>

          <h3>📝 Exemplo:</h3>
          <p style={{fontStyle: 'italic', padding: '15px', background: '#f9fafb', borderRadius: '8px'}}>
            Se você faz uma denúncia falsa contra um colega causando dano à reputação dele,
            você pode ser responsabilizado civilmente e criminalmente.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Limitações de Responsabilidade</h2>
          <p>
            <strong>O Grupo Vilarouca não é responsável por:</strong>
          </p>
          <ul>
            <li>Danos causados por denúncias falsas (você é responsável)</li>
            <li>Perda ou não recebimento de denúncias por problemas técnicos</li>
            <li>Atrasos na investigação (respeitando SLA)</li>
            <li>Consequências de ações tomadas com base em denúncias</li>
          </ul>

          <p style={{marginTop: '20px', padding: '15px', background: '#f0f9ff', borderRadius: '8px'}}>
            <strong>Proteção ao Denunciante:</strong> Porém, garantimos proteção contra retaliação
            para denúncias feitas de boa fé, mesmo que resultem em investigações que não confirmem as acusações.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Investigação e Conclusões</h2>
          <h3>Processo</h3>
          <ol>
            <li><strong>Recebimento:</strong> Denúncia recebida e registrada (1 dia)</li>
            <li><strong>Triagem:</strong> Classificação e priorização (5 dias)</li>
            <li><strong>Investigação:</strong> Apuração dos fatos (30-90 dias)</li>
            <li><strong>Conclusão:</strong> Parecer e decisão (30 dias)</li>
            <li><strong>Encerramento:</strong> Comunicação ao denunciante</li>
          </ol>

          <h3>✅ Seu Direito de Saber</h3>
          <p>
            Para denúncias <strong>identificadas</strong>: você será comunicado sobre o progresso
            e conclusões (respeitando confidencialidade de terceiros).
          </p>
          <p>
            Para denúncias <strong>anônimas</strong>: você pode acompanhar pelo Protocolo + PIN
            (informações limitadas por segurança).
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Confidencialidade e Sigilo</h2>
          <p>
            <strong>Nós protegemos a identidade de denunciantes</strong> conforme legislação:
          </p>
          <ul>
            <li>Acessos restritos por RBAC (apenas quem precisa sabe)</li>
            <li>Logs de auditoria rastreiam quem acessa</li>
            <li>Criptografia AES-256 em dados sensíveis</li>
            <li>Separação física entre identidade e denúncia</li>
          </ul>

          <div className="alert alert-success">
            <strong>❗ Exceções Legais:</strong> Podemos divulgar se exigido por lei, ordem judicial ou autoridades.
          </div>
        </section>

        <section className="legal-section">
          <h2>8. Disponibilidade do Sistema</h2>
          <p>
            Nos esforçamos para manter o sistema disponível 24/7, mas:
          </p>
          <ul>
            <li>Não garantimos 100% de disponibilidade</li>
            <li>Manutenção programada pode afetar acesso (comunicado com antecedência)</li>
            <li>Problemas técnicos podem causar indisponibilidade temporária</li>
          </ul>

          <p style={{marginTop: '15px'}}>
            <strong>Se sua denúncia não for enviada:</strong> O sistema tentará salvar rascunho.
            Tente novamente. Se persistir o problema, entre em contato com o DPO.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Governança e Compliance</h2>
          <p>
            Este Canal de Ética está em conformidade com:
          </p>
          <ul>
            <li><strong>LGPD</strong> (Lei Geral de Proteção de Dados)</li>
            <li><strong>Lei Anticorrupção</strong> (Lei 12.846/2013)</li>
            <li><strong>Código de Ética</strong> do Grupo Vilarouca</li>
            <li><strong>Boas práticas internacionais</strong> (SOX, ISO)</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>10. Alterações nos Termos</h2>
          <p>
            Podemos alterar estes Termos a qualquer momento.
            Continuando a usar o sistema após alterações, você aceita os novos termos.
          </p>
          <p><strong>Última atualização:</strong> 16 de Setembro de 2026</p>
        </section>

        <section className="legal-section">
          <h2>11. Contato</h2>
          <div className="contact-box">
            <p><strong>Dúvidas sobre estes Termos?</strong></p>
            <p>Data Protection Officer (DPO):</p>
            <p>Email: <a href="mailto:dpo@grupovilarouca.com.br">dpo@grupovilarouca.com.br</a></p>
            <p>Telefone: [A definir]</p>
          </div>
        </section>

        <div className="legal-footer">
          <p>✅ Ao usar o Canal de Ética, você concorda integralmente com estes Termos de Uso.</p>
          <p>📖 Leia também nossa <Link to="/privacidade">Política de Privacidade</Link></p>
        </div>
      </div>

      <div className="legal-back">
        <Link to="/" className="btn-back">← Voltar ao Canal de Ética</Link>
      </div>
    </div>
  );
}
